import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-address-book-search',
  standalone: true,
  imports: [FormsModule, MatFormFieldModule, MatIconModule, MatInputModule],
  template: `
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="address-search">
      <mat-icon matPrefix>manage_search</mat-icon>
      <mat-label>Suchbegriff (alle Felder)</mat-label>
      <input matInput [(ngModel)]="query" (ngModelChange)="changes.next($event)"
        autocomplete="off" aria-label="Volltextsuche im Adressbuch">
    </mat-form-field>
  `,
  styles: [`
    :host { display: block; min-width: 0; }
    .address-search { width: 100%; }
  `]
})
export class AddressBookSearchComponent implements OnDestroy {
  @Output() readonly queryChange = new EventEmitter<string>();
  readonly changes = new Subject<string>();
  private readonly destroyed = new Subject<void>();
  query = '';

  constructor() {
    this.changes.pipe(
      debounceTime(250),
      distinctUntilChanged(),
      takeUntil(this.destroyed)
    ).subscribe(query => this.queryChange.emit(query.trim()));
  }

  clear(): void {
    this.query = '';
    this.changes.next('');
  }

  reset(): void {
    this.query = '';
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
